export default __webpack_public_path__ + "static/media/img19.25eac6fc.jpeg";